import { flow, toPairs, fromPairs, map } from 'lodash/fp';

export default flow(
  toPairs,
  map(([key, value]) => [value, key]),
  fromPairs,
);
